import type { ActivitySubjectStatusProps } from "./activity-subject-status.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { STATUS_COLOR } from "@/constants/StatusColor";
import { Tag } from "@/ui/tag";

export const ActivitySubjectStatus = ({
  activity,
}: ActivitySubjectStatusProps) => {
  const { t } = useTranslation();

  const isDeleted = activity.subject?.deleted_at !== null;
  const status = isDeleted ? "DELETED" : "ACTIVE";
  const statusLabel = isDeleted ? "deleted" : "active";

  return (
    <Tag color={STATUS_COLOR[status]}>
      <Typography.Text>{t(`global:${statusLabel}`)}</Typography.Text>
    </Tag>
  );
};
